import * as React from 'react';
import { getOr } from '@/utils/options';
import { Heading, Label, Paragraph } from 'components/src/typography';
import { TabGroupFieldsFragment } from 'types/generated';
import TabsSection from './Tabs';

type Props = {
  data: TabGroupFieldsFragment;
};

const TabGroup = ({ data }: Props) => {
  return (
    <div className="w-full">
      {data.tagline && <Label classes="text-black-75">{data.tagline}</Label>}
      <Heading variant="xs" classes="text-black-10 mb-16">
        {getOr(data.title, '')}
      </Heading>
      {data.description && <Paragraph classes="mb-32 max-w-[500px] text-black-100">{data.description}</Paragraph>}
      <TabsSection data={data} />
    </div>
  );
};

export default TabGroup;
